import useUrl from './helpers/useUrl'

export default (client) => {
  const root = useUrl('bm')

  return {
    /**
     * @returns {Promise<Response<GetAvailableBMListResponse>>}
     * */
    getAvailableList() {
      const url = root('list/all')
      return client.get(url)
    },
    /**
     * @returns {Promise<Response<GetListUserBMResponse>>}
     * */
    getListUser() {
      const url = root('list/user')
      return client.get(url)
    },
    /**
     * @param {object} OpenBonusBMDTO
     * @param {string} OpenBonusBMDTO.uuid
     *
     * @returns {Promise<Response<OpenBonusResponse>>}
     * */
    openBonus({ uuid }) {
      const url = root('open')
      return client.post(url, { uuid })
    },
    /**
     * @returns {Promise<Response<GetUserInfoBMResponse>>}
     * */
    getUserInfo() {
      const url = root('account')
      return client.get(url)
    },
    /**
     * @returns {Promise<Response<GetMinDepositBMResponse>>}
     * */
    getMinDeposit() {
      const url = root('campaign')
      return client.get(url)
    },

  }
}

/** @typedef {object} GetAvailableBMListResponse
 * @property {boolean} status
 * @property {object[]} result
 * @property {string} result.uuid
 * @property {string} result.name
 * @property {string} result.description
 * @property {string} result.iconUrl
 * @property {object[]} result.gifts
 * @property {string} result.gifts.uuid
 * @property {string} result.gifts.name
 * @property {string} result.gifts.description
 * @property {number} result.gifts.referenceId
 * @property {string} result.gifts.serviceName
 * @property {number} result.gifts.serviceReferenceId
 * @property {string} result.gifts.iconUrl
 */

/** @typedef {object} GetListUserBMResponse
 * @property {boolean} status
 * @property {object[]} result
 * @property {string} result.uuid
 * @property {null} result.gift
 * @property {boolean} result.isExpired
 * @property {string} result.status
 * @property {number} result.expiresIn
 * @property {object[]} result.gifts
 * @property {string} result.gifts.uuid
 * @property {string} result.gifts.name
 * @property {string} result.gifts.description
 * @property {number} result.gifts.referenceId
 * @property {string} result.gifts.serviceName
 * @property {number} result.gifts.serviceReferenceId
 * @property {string} result.gifts.iconUrl
 * @property {string} result.description
 * @property {string} result.name
 */

/** @typedef {object} OpenBonusResponse
 * @property {boolean} status
 * @property {object} result
 * @property {string} result.uuid
 * @property {string} result.status
 * @property {object[]} result.gifts
 * @property {string} result.gifts.uuid
 * @property {string} result.gifts.name
 * @property {string} result.gifts.description
 * @property {number} result.gifts.referenceId
 * @property {string} result.gifts.serviceName
 * @property {number} result.gifts.serviceReferenceId
 * @property {string} result.gifts.iconUrl
 */

/** @typedef {object} GetUserInfoBMResponse
 * @property {boolean} status
 * @property {object} result
 * @property {number} result.userId
 * @property {number} result.balance
 * @property {number[]} result.goals
 * @property {number} result.progress
 * @property {number} result.round
 */

/** @typedef {object} GetMinDepositBMResponse
 * @property {boolean} status
 * @property {object} result
 * @property {number} result.minDeposit
 */
